var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.75 8.863c-.018-2.099 1.656-3.122 1.734-3.167-.949-1.434-2.419-1.631-2.937-1.645-1.237-.134-2.433.766-3.063.766-.64 0-1.61-.752-2.656-.731-1.345.02-2.602.83-3.29 2.08-1.423 2.556-.362 6.31 1.003 8.376.68 1.013 1.477 2.141 2.52 2.102 1.02-.042 1.403-.675 2.633-.675 1.22 0 1.579.675 2.643.65 1.094-.017 1.785-1.015 2.442-2.034a8.6 8.6 0 0 0 1.118-2.359c-.027-.017-2.127-.85-2.148-3.363M9.74 2.69c.55-.713.925-1.68.82-2.664-.793.035-1.789.57-2.358 1.266-.505.615-.959 1.62-.84 2.565.888.067 1.806-.467 2.378-1.167"
  })));
};
export default SvgApple;